import { useContext } from "react";
import { useHistory } from "react-router-dom";
import type { OfferStatusType } from "../../../api/quotation/types";
import { brand } from "../../../context";
import { TranslationContext } from "../../../umbilical_tools";

export type StatusTagProps = {
  offerStatus: OfferStatusType | null;
  status: "SE" | "DR" | "RJ" | "AC";
  statusDisplay: string;
};

export function StatusTag({ offerStatus, status, statusDisplay }: StatusTagProps) {
  const { t } = useContext(TranslationContext) as { t: (key: string) => string };

  let backgroundClass = "bg-gray-200";
  let textColorClass = "text-gray-900";
  let displayText = statusDisplay;

  // Use offer_status if available, otherwise fall back to status
  if (offerStatus) {
    switch (offerStatus) {
      case "quotation_sent":
        backgroundClass = "bg-green-500";
        textColorClass = "text-white";
        displayText = t("quotationSent");
        break;
      case "offer_in_progress":
        backgroundClass = "bg-amber-500";
        textColorClass = "text-white";
        displayText = t("offerInProgress");
        break;
      case "offer_available":
        backgroundClass = "bg-orange-500";
        textColorClass = "text-white";
        displayText = t("offerAvailable");
        break;
      case "offer_accepted":
        backgroundClass = "bg-blue-500";
        textColorClass = "text-gray-100";
        displayText = t("offerAccepted");
        break;
      case "offer_expired":
        backgroundClass = "bg-red-500";
        textColorClass = "text-white";
        displayText = t("offerExpired");
        break;
    }
  } else {
    // Fallback to old status logic
    if (status === "SE") {
      backgroundClass = "bg-green-500";
      textColorClass = "text-white";
    } else if (status === "AC") {
      backgroundClass = "bg-blue-500";
      textColorClass = "text-gray-100";
    } else if (status === "DR") {
      backgroundClass = "bg-amber-500";
      textColorClass = "text-gray-900";
    } else if (status === "RJ") {
      backgroundClass = "bg-red-500";
      textColorClass = "text-white";
    }
  }

  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-medium ${backgroundClass} ${textColorClass}`}
    >
      {displayText}
    </span>
  );
}

export type ViewOfferButtonProps = {
  offerReference: string;
};

export function ViewOfferButton({ offerReference }: ViewOfferButtonProps) {
  const url = `https://travelcompanion.easytravel.tech/trip_info/REF__${offerReference}`;
  return (
    <button
      type="button"
      className="Button text-xs! p-1! bg-green-500! border-green-600!"
      data-brand={brand}
      onClick={() => {
        window.open(url, "_blank") || window.location.replace(url);
      }}
    >
      View Offer
    </button>
  );
}

export type ViewQuotationChatButtonProps = {
  chatSessionUid: string;
};

export function ViewQuotationChatButton({ chatSessionUid }: ViewQuotationChatButtonProps) {
  const history = useHistory();
  return (
    <button
      type="button"
      className="Button text-xs! p-1!"
      data-brand={brand}
      onClick={() => {
        history.push(`/quotation-request-chat?chat_session_uid=${chatSessionUid}`);
      }}
    >
      View A.I Chat
    </button>
  );
}
